// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__TBnPa","col":"styles_col__1VhyE","fulfillmentStatus":"styles_fulfillmentStatus__2ygNX","emailCol":"styles_emailCol__20X5T"};